import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { WARRANTY_STEP } from "../../common/constant";
import { selectInfoWarranty } from "../../redux/reducers/slice/warranty";
import { preciseDiff } from "../../shared/helpers";
import "./infoProductStyle.scss";

const InformationProduct = (props: any) => {
  const { step = WARRANTY_STEP.RESULT } = props;
  const { t } = useTranslation();
  const infoWarranty = useSelector(selectInfoWarranty);

  return (
    <>
      <div className="product-container">
        <div className="product-title">
          {/* <span className="sub-title">&gt; </span> */}
          <li className="main-content">
            {step === WARRANTY_STEP.REGISTER
              ? "Thông tin sản phẩm"
              : "Sản phẩm"}
          </li>
        </div>

        <div className="product">
          <div className="product__image">
            <img src={infoWarranty?.product_feature_img} alt="" />
          </div>
          <div className="product-information">
            <span className="product-information__name sub-title">
              {infoWarranty?.product_name}
            </span>
            <span className="product-information__feature sub-title">
              {infoWarranty?.product_feature_name}
            </span>
            {!!infoWarranty?.allow_active_warranty && (
              <span className="product-information__status main-content">
                {t("active_warranty_product_warranty_status_title")}:{" "}
                <strong>
                  {infoWarranty?.is_activated
                    ? t("active_warranty_activated_status")
                    : t("active_warranty_not_activated_yet_status")}
                </strong>
              </span>
            )}
            {infoWarranty?.warranty_duration_in_month ? (
              <span className="product-information__status product-information__duration main-content">
                Thời gian bảo hành:{" "}
                <strong>
                  {infoWarranty?.warranty_duration_in_month / 12} năm
                </strong>{" "}
                <span className="product-information__duration--more-info">
                  (tính từ ngày mua sản phẩm)
                </span>
              </span>
            ) : (
              <span className="product-information__duration main-content">
                <span className="product-information__duration--more-info">
                  (Thời gian bảo hành tính từ ngày mua sản phẩm)
                </span>
              </span>
            )}
            {infoWarranty?.is_activated && (
              <>
                <span className="product-information__status main-content">
                  {t("activation_date")}:{" "}
                  <strong>
                    {moment(infoWarranty?.activation_date).format("DD/MM/yyyy")}
                  </strong>
                </span>
                <span className="product-information__status main-content">
                  {t("active_warranty_warranty_from_date_title")}:{" "}
                  <strong>
                    {infoWarranty?.warranty_from_date
                      ? moment(infoWarranty?.warranty_from_date).format(
                          "DD/MM/yyyy"
                        )
                      : "Chưa cập nhật thông tin"}
                  </strong>
                </span>
                <span className="product-information__status main-content">
                  {t("remaining_warranty_in_days")}:{" "}
                  <strong>
                    {preciseDiff(
                      moment(infoWarranty?.activation_date),
                      moment(infoWarranty?.activation_date).add(
                        "days",
                        infoWarranty?.remaining_warranty_in_days
                      ),
                      false
                    )}
                  </strong>
                </span>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default InformationProduct;
